// extracted by css-extract-rspack-plugin
export default {"HeaderGridCellLayout":"dummy-table-header-cell-module__HeaderGridCellLayout__asb4fxm"};